import * as React from 'react';
import {View, Text} from 'react-native';
import {images} from '../../../../assets/icons';
import {useStyles} from '../../../hooks/styles';
import {useTheme} from '../../../theme';
import {Modal} from '../../modal/modal';

export default () => {
  const theme = useTheme();
  const styles = useStyles(() => ({
    card: {
      position: 'relative',
      width: 376,
      height: 64,
      paddingHorizontal: 20,
      paddingVertical: 12,
      borderRadius: 14,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      shadowColor: theme.color.primaryBlackColor,
      shadowOffset: {width: 0, height: 0},
      shadowOpacity: 0.1,
      shadowRadius: 4,
      elevation: 1,
      zIndex: 1,
      opacity: 1,
      backgroundColor: theme.color.whiteTextColor,
      alignSelf: 'flex-end',
    },
    badge: {
      width: 40,
      height: 40,
      borderRadius: 20,
      backgroundColor: theme.color.borderColor,
      justifyContent: 'center',
      alignItems: 'center',
    },
    text: {
      ...theme.fonts.action,
      color: theme.color.textColor,
    },
  }));

  return (
    <Modal
      allowClicksThroughOverlay
      customContent={
        <View style={styles.card}>
          <View style={styles.badge}>
            <images.NoInternet color={theme.color.labelText} />
          </View>
          <Text style={styles.text}>Нет подключения к интернету</Text>
        </View>
      }
    />
  );
};
